import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { toggleSection, onClickAccHandler, sectionIsOpen, accScroll } from '../../page-accordion';
import moment from 'moment';
import { nl2br }  from '../../util';

class Component extends BaseComponent {
    constructor(props) {
        super(props);

        let state = {
            open_chapters: [],
            linkSelect: false,
        };

        if (props.route) {
            state.open_chapters.push(props.route);
        }

        this.state = state;
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.route != this.props.route) {
            if (nextProps.route != '') {
                if (nextProps.route === 'main') {
                    this.setState({open_chapters: []});
                    accScroll('main', 500);
                } else {
                    if (!this.state.linkSelect) {
                        let opened = toggleSection(this.state.open_chapters, nextProps.route);
                        const state = this.state;
                        state.open_chapters = opened;
                        this.setState(state);
                    }
                    this.setState({linkSelect: false});
                }
            }

            return true;
        }
        if (nextState != this.state) {
            return true;
        }
        if (nextProps.report != this.props.report) {
            return true;
        }

        return false;
    }

    /* eslint-disable max-len */
    render({ report }) {
        const chapter_1_body = nl2br(report.product.display.sections[0].block[0].content[0].body);

        return (
            <yearly-forecast-report>
                <br />
                <div className='report-links'>
                    <a className='print-links' href='#chapter-1' onClick={(e) => { this.goTo(e, 'chapter-1', true); }}>
                        Chapter 1: Before You Read Your Forecasts
                    </a>
                    {this.renderChapterLinks()}
                    <br />
                    <br />
                    <a href='/astrology/glossary' target='_blank' rel='noopener' className='is-hidden-print'>
                        Glossary of Astrological Terms and Abbreviations
                    </a>
                </div>
                <div
                    className={`report-item ${sectionIsOpen(this.state.open_chapters, 'chapter-1') ? 'is-open' : 'is-closed'}`}
                >
                    <a
                        id='chapter-1'
                        href='#chapter-1'
                        onClick={(e) => { this.goTo(e, 'chapter-1', false); }}
                        className='report-item-tab'
                    >
                        <h5>Chapter 1:</h5>
                        <h2>Before You Read Your Forecasts</h2>
                    </a>
                    <div className='report-item-content'>
                        <p dangerouslySetInnerHTML={{__html: chapter_1_body}} />
                        <div className='has-text-right'>
                            <a
                                href='#'
                                onClick={(e) => { this.goTo(e, 'main', true); }}
                                className='is-hidden-print'
                            >
                                Back to Top
                            </a>
                        </div>
                    </div>
                </div>
                {this.renderChapters()}
                <div className='back-to-top'>
                    <a href='#' onClick={(e) => { this.goTo(e, 'top', false); }} />
                </div>
            </yearly-forecast-report>
        );
    }

    renderChapterLinks = () => {
        const blocks = this.props.report.product.display.sections[1].block;

        return blocks.map((block, i) => {
            if (Array.isArray(block.content) && block.type == 'Content') {
                const chapterNum = i + 2;
                const chapter = `chapter-${chapterNum}`;

                return (
                    <a
                        className='print-links'
                        href={'#' + chapter}
                        onClick={(e) => {this.goTo(e, chapter, true);}}
                    >
                        Chapter {chapterNum}: {block.content[0].title}
                    </a>
                );
            }

            return null;
        });
    }

    renderChapters = () => {
        const blocks = this.props.report.product.display.sections[1].block;
        return blocks.map((block, i) => {
            if (Array.isArray(block.content) && block.type == 'Content') {
                const chapterNum = i + 2;
                const chapter = `chapter-${chapterNum}`;
                const tags = block.content[0].tags;
                const className=`report-item ${sectionIsOpen(this.state.open_chapters, chapter) ? 'is-open' : 'is-closed'}`;

                return (
                    <div className={className}>
                        <a
                            id={chapter}
                            href={'#' + chapter} onClick={(e) => { this.goTo(e, chapter, false); }}
                            className='report-item-tab'
                        >
                            <h5>Chapter {chapterNum}:</h5>
                            <h2>{block.content[0].title}</h2>
                        </a>
                        <div className='report-item-content'>
                            <p dangerouslySetInnerHTML={{__html: nl2br(block.content[0].body)}} />
                            {this.renderTransits(chapter, tags)}
                            <div className='has-text-right'>
                                <a href='#' onClick={(e) => { this.goTo(e, 'main', true); }} className='is-hidden-print'>
                                    Back to Top
                                </a>
                            </div>
                        </div>
                    </div>
                );
            }

            return null;
        });
    }

    renderTransits = (chapter, tags) => {

        const blocks = this.props.report.product.display.sections[1].block;
        const block = blocks[blocks.length - 1];

        if (Array.isArray(block.content) && block.type == 'Interpretation') {
            return block.content.map(transit => {
                const ttags = transit.tags.filter(value => value != 'transit');
                const display = ttags.filter(tag => tags.indexOf(tag) !== -1);

                if (display.length) {
                    return [
                        <h2>{transit.title}</h2>,
                        this.renderTransitDates(transit),
                        transit.body.map((body, i) => {
                            if (i == 0 && transit.header) {
                                return (
                                    <p>
                                        <b>{transit.header}: </b>
                                        {nl2br(body)}
                                    </p>
                                );
                            }

                            return (
                                <p>{nl2br(body)}</p>
                            );
                        }),
                    ];
                }

                return null;
            });
        }

        return null;
    }

    renderTransitDates = (transit) => {
        if (transit.dates) {
            if (transit.dates.peak && transit.dates.start && transit.dates.end) { //all 3 dates
                return [
                    <h5>Peak Date: {moment(transit.dates.peak).format('MMMM D, YYYY')}</h5>,
                    <h6>
                        Influential Transit Duration: {
                            moment(transit.dates.start).format('MMMM D, YYYY') +
                            ' - ' +
                            moment(transit.dates.end).format('MMMM D, YYYY')
                        }
                    </h6>,
                ];
            } else if (transit.dates.peak) { //peak only
                return (
                    <h5>Peak Date: {moment(transit.dates.peak).format('MMMM D, YYYY')}</h5>
                );
            }

            return null;
        }

        return null;
    }

    goTo = (e, chapter, shouldClose) => {
        e.preventDefault();
        if (chapter === 'top') {
            accScroll('main', 100);
            return;
        }
        let clickResult = onClickAccHandler(this.state.open_chapters, chapter, this.props.route);
        const state = this.state;
        if (shouldClose) {
            if (chapter === 'main') {
                state.open_chapters = [];
                clickResult[2] = false;
            } else {
                clickResult[2] = true;
                state.open_chapters = [chapter];
                state.linkSelect = true;
            }
            clickResult[1] = true;
        } else {
            state.open_chapters = clickResult[0];
        }
        this.setState(state);
        if (clickResult[1] == true) {
            this.props.routeTo(chapter);
        }
        if (clickResult[2] == true) {
            if (state.linkSelect) {
                accScroll(chapter, 500);
            } else {
                accScroll(chapter, 400);
            }
        }
    }
    /* eslint-enable max-len */
}

const mapStateToProps = (state) => ({
    route: state.route,
    report: state.report,
});

const mapDispatchToProps = (dispatch) => ({
    routeTo: (hash) => dispatch({ type: 'route:to', payload: hash }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);
